import { useTheme } from 'styled-components'

import { BriqTheme } from '../components/theme'

export const useBriqTheme = () => useTheme() as BriqTheme
